var parent = require('../../es/object/get-own-property-descriptor');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/object/get-own-property-descriptor.js
// module id = 1453
// module chunks = 25